import React from 'react';
export function formatDate(iso, language) {
    var pastDate = new Date(iso);
    var now = new Date();
    // @ts-ignore
    var diffInMs = now - pastDate;
    var diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    var minutesWord;
    var lastDigit = diffInMinutes % 10;
    var lastTwoDigits = diffInMinutes % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        minutesWord = language === 'en' ? 'minutes' : 'минут';
    }
    else if (lastDigit === 1) {
        minutesWord = language === 'en' ? 'minute' : 'минуту';
    }
    else if (lastDigit >= 2 && lastDigit <= 4) {
        minutesWord = language === 'en' ? 'minutes' : 'минуты';
    }
    else if (lastDigit === 0 && lastTwoDigits === 0) {
        minutesWord = language === 'en' ? 'less than a minute' : 'менее минуты';
    }
    else {
        minutesWord = language === 'en' ? 'minutes' : 'минут';
    }
    if (diffInMinutes >= 60) {
        var day = String(pastDate.getDate()).padStart(2, '0');
        var month = String(pastDate.getMonth() + 1).padStart(2, '0');
        var year = pastDate.getFullYear();
        var hours = String(pastDate.getHours()).padStart(2, '0');
        var minutes = String(pastDate.getMinutes()).padStart(2, '0');
        return "".concat(day, ".").concat(month, ".").concat(year, "  ").concat(hours, ":").concat(minutes);
    }
    return "".concat(diffInMinutes > 0 ? diffInMinutes : '', " ").concat(minutesWord, " ").concat(language === 'en' ? 'ago' : 'назад');
}
export function formatPostDate(dateCreate, dateLastChange, language) {
    if (!dateCreate) {
        return null;
    }
    var createDate = new Date(dateCreate);
    var lastChangeDate = dateLastChange ? new Date(dateLastChange) : null;
    var options = {
        hour: '2-digit',
        minute: '2-digit',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    };
    var locale = language === 'ru' ? 'ru-RU' : 'en-US';
    var formatter = new Intl.DateTimeFormat(locale, options);
    var formattedCreate = formatter.format(createDate).replace(/\//g, '.');
    if (lastChangeDate && dateCreate !== dateLastChange) {
        var formattedLastChange = formatter
            .format(lastChangeDate)
            .replace(/\//g, '.');
        return "".concat(formattedLastChange, " (").concat(language === 'ru' ? 'изменено' : 'edited', ")");
    }
    return formattedCreate;
}
//# sourceMappingURL=formatDate.js.mapimport React from 'react';
export function formatDate(iso, language) {
    var pastDate = new Date(iso);
    var now = new Date();
    // @ts-ignore
    var diffInMs = now - pastDate;
    var diffInMinutes = Math.floor(diffInMs / (1000 * 60));
    var minutesWord;
    var lastDigit = diffInMinutes % 10;
    var lastTwoDigits = diffInMinutes % 100;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        minutesWord = language === 'en' ? 'minutes' : 'минут';
    }
    else if (lastDigit === 1) {
        minutesWord = language === 'en' ? 'minute' : 'минуту';
    }
    else if (lastDigit >= 2 && lastDigit <= 4) {
        minutesWord = language === 'en' ? 'minutes' : 'минуты';
    }
    else if (lastDigit === 0 && lastTwoDigits === 0) {
        minutesWord = language === 'en' ? 'less than a minute' : 'менее минуты';
    }
    else {
        minutesWord = language === 'en' ? 'minutes' : 'минут';
    }
    if (diffInMinutes >= 60) {
        var day = String(pastDate.getDate()).padStart(2, '0');
        var month = String(pastDate.getMonth() + 1).padStart(2, '0');
        var year = pastDate.getFullYear();
        var hours = String(pastDate.getHours()).padStart(2, '0');
        var minutes = String(pastDate.getMinutes()).padStart(2, '0');
        return "".concat(day, ".").concat(month, ".").concat(year, "  ").concat(hours, ":").concat(minutes);
    }
    return "".concat(diffInMinutes > 0 ? diffInMinutes : '', " ").concat(minutesWord, " ").concat(language === 'en' ? 'ago' : 'назад');
}
export function formatPostDate(dateCreate, dateLastChange, language) {
    if (!dateCreate) {
        return null;
    }
    var createDate = new Date(dateCreate);
    var lastChangeDate = dateLastChange ? new Date(dateLastChange) : null;
    var options = {
        hour: '2-digit',
        minute: '2-digit',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    };
    var locale = language === 'ru' ? 'ru-RU' : 'en-US';
    var formatter = new Intl.DateTimeFormat(locale, options);
    var formattedCreate = formatter.format(createDate).replace(/\//g, '.');
    if (lastChangeDate && dateCreate !== dateLastChange) {
        var formattedLastChange = formatter
            .format(lastChangeDate)
            .replace(/\//g, '.');
        return "".concat(formattedLastChange, " (").concat(language === 'ru' ? 'изменено' : 'edited', ")");
    }
    return formattedCreate;
}
//# sourceMappingURL=formatDate.js.map